function getCookie(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? JSON.parse(match[2]) : null;
}

const consent = getCookie("cookiesNotification");

function activateButtons(){
  // debugger;
  const customCookies = getCookie("cookiesNotification");
    jQuery('input.ot-quick-checkbox:not(#quick-cat-2544621)').each(function () {
      jQuery(this).attr('checked', false)
    })
    jQuery('omgCookie-input-switch:not(#switch-omgCookie-necessary)').each(function () {
      jQuery(this).attr('checked', false)
    })
  
  
  if(customCookies){
    jQuery('span#visitorId').text(customCookies[0].visitorId);
    jQuery('span#consent-on').text(customCookies[0].consentOn);
    jQuery('span#expires-at').text(customCookies[0].expires);
    
    jQuery('p.privacy-popup-category span.necessary').text((customCookies[0].categoriesSelected).includes('necessary') ? "✔" : "✕");
    jQuery('p.privacy-popup-category span.preferences').text((customCookies[0].categoriesSelected).includes('preferences') ? "✔" : "✕");
    jQuery('p.privacy-popup-category span.marketing').text((customCookies[0].categoriesSelected).includes('marketing') ? "✔" : "✕");
    jQuery('p.privacy-popup-category span.analytics').text((customCookies[0].categoriesSelected).includes('analytics') ? "✔" : "✕");
    
    jQuery.each(customCookies[0].categoriesSelected, function (i, v) {
      jQuery(`input.ot-quick-checkbox[data-id="${v}"]`).attr('checked', true)
    })
    jQuery.each(customCookies[0].categoriesSelected, function (i, v) {
      jQuery(`input.omgCookie-input-switch[data-id="${v}"]`).attr('checked', true)
    })
  }
}
activateButtons();
jQuery('label.ot-quick-trigger:not(.disabled)').click(function () {
  const $checkbox = jQuery(`#${jQuery(this).attr('for')}`);
  if ($checkbox.attr('checked') == 'true' || $checkbox.attr('checked') == 'checked') {
      $checkbox.attr('checked', false)
  }else{
      $checkbox.attr('checked', true)
  }
});
jQuery('label.omgCookie:not(.disabled)').click(function () {
  const $checkbox = jQuery(`#${jQuery(this).attr('for')}`);
  if ($checkbox.attr('checked') == 'true' || $checkbox.attr('checked') == 'checked') {
      $checkbox.attr('checked', false)
  }else{
      $checkbox.attr('checked', true)
  }
});

jQuery("span#cookies-submit:not(.disabled)").click(function () {
  const selectedCategories = jQuery("input.ot-quick-checkbox[checked]")
    .map(function () {
      return jQuery(this).data("id").toLowerCase();
    })
    .get();

  const visitorId = Math.random().toString(36).substring(2, 10);
  const now = new Date();
  const consentOn = now.toISOString();
  const expires = new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000).toISOString();

  const consentData = [{
    categoriesSelected: selectedCategories,
    visitorId: visitorId,
    consentOn: consentOn,
    expires: expires
  }];

  document.cookie = 'cookiesNotification='+JSON.stringify(consentData);

  jQuery('div#cookies-wrapper').hide()
  jQuery('.cst-reopener-wrapper.cst-reopener-text').show()
  // console.log("Cookie set:", consentData);
});
jQuery("button.cookies-btn.btn-select").click(function () {
  const selectedCategories = jQuery("input.omgCookie-input-switch[checked]")
    .map(function () {
      return jQuery(this).data("id").toLowerCase();
    })
    .get();

  const visitorId = Math.random().toString(36).substring(2, 10);
  const now = new Date();
  const consentOn = now.toISOString();
  const expires = new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000).toISOString();

  const consentData = [{
    categoriesSelected: selectedCategories,
    visitorId: visitorId,
    consentOn: consentOn,
    expires: expires
  }];

  document.cookie = 'cookiesNotification='+JSON.stringify(consentData);

  jQuery('div#cookies-wrapper').hide()
  jQuery('.cst-reopener-wrapper.cst-reopener-text').show()
  // console.log("Cookie set:", consentData);
});
jQuery("button.cookies-btn.btn-all").click(function () {
  const selectedCategories = jQuery("input.omgCookie-input-switch")
    .map(function () {
      return jQuery(this).data("id").toLowerCase();
    })
    .get();

  const visitorId = Math.random().toString(36).substring(2, 10);
  const now = new Date();
  const consentOn = now.toISOString();
  const expires = new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000).toISOString();

  const consentData = [{
    categoriesSelected: selectedCategories,
    visitorId: visitorId,
    consentOn: consentOn,
    expires: expires
  }];

  document.cookie = 'cookiesNotification='+JSON.stringify(consentData);

  jQuery('div#cookies-wrapper').hide()
  jQuery('.cst-reopener-wrapper.cst-reopener-text').show()
  // console.log("Cookie set:", consentData);
});



if(!consent){
  jQuery('div#cookies-wrapper').show()
}else{
  jQuery('.cst-reopener-wrapper.cst-reopener-text').show()
}

jQuery("span.cst-reopen-trigger").click(function () {
    activateButtons()
    jQuery('.cst-reopener-wrapper.cst-reopener-text').hide()
    jQuery(".cookies-privacy-popup").show()
  
})

jQuery("button#ot-privacy-popup-withdraw").click(function () {
    // debugger;
    document.cookie = 'cookiesNotification=false;';
    activateButtons()
    jQuery('div#cookies-wrapper').show()
    jQuery('.cookies-privacy-popup').hide()

    jQuery('div#cookies-message').show()
    jQuery('div#cookies-preferences-wrapper').hide()
    jQuery('div#ot-quick-categories').show()
    jQuery('span.ot-cookie').show()
    jQuery('button.cookies-btn').hide()
})
jQuery("button#ot-privacy-popup-change-settings").click(function () {
    activateButtons()
    jQuery('div#cookies-wrapper').show()
    jQuery('.cookies-privacy-popup').hide()
})
jQuery("span#cookies-dismiss").click(function () {
  window.location.href = "https://www.google.com/";
});
jQuery('input.ot-quick-checkbox').change(function () {
    var otQuickCheckbox = jQuery('input.ot-quick-checkbox[checked]').length
    if(otQuickCheckbox){
        jQuery('span#cookies-submit').removeClass('disabled')
    }else{
        jQuery('span#cookies-submit').addClass('disabled')
    }
})
jQuery("span#cookies-preferences").click(function () {
    activateButtons()
    jQuery('div#cookies-message').hide()
    jQuery('div#cookies-preferences-wrapper').show()
    jQuery('div#ot-quick-categories').hide()
    jQuery('span.ot-cookie').hide()
    jQuery('button.cookies-btn').show()
})
jQuery('.otCookiesNotification #cookies-body .accordion-item button.header-accord').click(function () {
    if(jQuery(this).attr('aria-expanded') == 'false'){
        jQuery(this).attr('aria-expanded', true)
    }else{
        jQuery(this).attr('aria-expanded', false)
    }
})